import React from 'react';
import { connect } from 'react-redux';
import AirportSpotSummary from 'common/facility-summary-airport/v1';
import StarRatingWithCategory from 'common/star-rating-with-category';
import Image from 'common/image';
import BenefitMessage from '../benefit-message';
import useConfig from 'hooks/use-config';
import { Button } from '@spothero/ui';
import { useScrollToReviews } from 'common/spot-details/context/ScrollToReviewsContext';
export const SpotDetailsHeader = ({ facility, percentLowerPrice, isAdmin, linearMeters, walkingMeters, showBenefitMessage = false, }) => {
    const { staticBaseUrl } = useConfig();
    const { scrollToReviews } = useScrollToReviews();
    const { id, title, logos, images, rating_info: ratingInfo, airport, amenities_full: amenitiesList, } = facility;
    const { details: { code: iataCode }, } = airport;
    const { number_of_ratings: numberOfReviews, star_rating: starRating, } = ratingInfo;
    const handleStarRatingClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollToReviews();
    };
    const logoId = logos && logos.length > 0
        ? logos[0].id
        : images && images.length > 0
            ? images[0].id
            : null;
    const logoProps = {
        width: 144,
        height: 144,
        alt: `Photo of ${title}`,
        ...(logoId
            ? { cloudinaryImageId: logoId }
            : { src: `${staticBaseUrl}img/missing-image.png` }),
    };
    return (<div className="SpotDetailsHeader">
            <div className="SpotDetailsHeader-top-content">
                <div className="SpotDetailsHeader-photo">
                    <Image {...logoProps}/>
                </div>
                <div className="SpotDetailsHeader-details">
                    {showBenefitMessage && (<BenefitMessage percentLowerPrice={percentLowerPrice} iataCode={iataCode}/>)}
                    <h2 itemProp="name">{unescape(title)}</h2>
                    <Button variant="tertiary" padding={0} minWidth="auto" height="auto" aria-label="Scroll to reviews" data-testid="SpotDetailsHeader-StarRatingWithCategory" marginRight={2} _hover={{ opacity: 0.8 }} onClick={handleStarRatingClick}>
                        <StarRatingWithCategory numberOfReviews={numberOfReviews} starRating={starRating} countStyles={{
            textDecoration: 'underline',
        }}/>
                    </Button>
                    {isAdmin && (<a className="SpotDetailsHeader-admin-link" href={`/admin/spots/${id}`} target="_blank" rel="noopener noreferrer">
                            Facility Admin Page
                        </a>)}
                    <AirportSpotSummary data={airport} amenities={amenitiesList} linearMeters={linearMeters} walkingMeters={walkingMeters}/>
                </div>
            </div>
            <div className="SpotDetailsHeader-bottom-content">
                <AirportSpotSummary data={airport} amenities={amenitiesList} linearMeters={linearMeters} walkingMeters={walkingMeters}/>
            </div>
        </div>);
};
const mapStateToProps = state => {
    const { user: { data: { isAdmin }, }, } = state;
    return {
        isAdmin,
    };
};
export default connect(mapStateToProps)(SpotDetailsHeader);
